// src/pages/gt3x/Streamer.jsx
import { useEffect, useMemo, useState } from "react";
import { fetchSheetViaProxy } from "../../lib/sheets";

// Tab in Google Sheets:
// Spalte A = Fahrer
// Spalte B = Link
// Spalte C = Team

// MUSS NOCH AUF SPECIAL X STREAMER SHEET GEÄNDERT WERDEN !!!!!!!!!!!!!!!!!!!!!!!!!
const SHEET_ID = "1bdWoKQm-B96F6fGmeB7Lo0BAiKDglXsQboXaVdtkIZI";
const RANGE = "Streamers!A1:C500";

const TWITCH_ICON = "https://racevision.info/assets/twitch.png";
const YOUTUBE_ICON = "https://racevision.info/assets/youtube.png";

function normalizeUrl(value) {
    const str = String(value ?? "").trim();
    if (!str) return "";

    if (/^https?:\/\//i.test(str)) return str;
    return `https://${str.replace(/^https?:\/\//i, "")}`;
}

function getChannelNameFromUrl(url) {
    const href = normalizeUrl(url);
    if (!href) return "";

    try {
        const u = new URL(href);
        const parts = u.pathname.split("/").filter(Boolean);

        if (!parts.length) return u.hostname.replace(/^www\./i, "");

        // letzter Teil nach dem letzten /
        return parts[parts.length - 1];
    } catch {
        const clean = href.split("?")[0].replace(/\/+$/, "");
        const parts = clean.split("/").filter(Boolean);
        return parts.length ? parts[parts.length - 1] : clean;
    }
}

function getPlatform(url) {
    const href = normalizeUrl(url).toLowerCase();

    if (href.includes("twitch.tv")) return "twitch";
    if (href.includes("youtube.com") || href.includes("youtu.be")) return "youtube";
    return "";
}

function renderChannelLink(value) {
    const href = normalizeUrl(value);
    if (!href) return "";

    const platform = getPlatform(href);
    const channelName = getChannelNameFromUrl(href) || href;

    const iconSrc =
        platform === "twitch"
            ? TWITCH_ICON
            : platform === "youtube"
                ? YOUTUBE_ICON
                : "";

    return (
        <div style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
            {iconSrc ? (
                <img
                    src={iconSrc}
                    alt={platform}
                    style={{
                        height: platform === "twitch" ? 28 : 24,
                        width: platform === "twitch" ? 28 : 24,
                        objectFit: "contain",
                        display: "block",
                        flexShrink: 0,
                    }}
                />
            ) : null}

            <a
                className="link-accent"
                href={href}
                target="_blank"
                rel="noreferrer"
                title={href}
            >
                {channelName}
            </a>
        </div>
    );
}

export default function Streamer() {
    const [data, setData] = useState({ header: [], rows: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const res = await fetchSheetViaProxy({ range: RANGE, sheetId: SHEET_ID });
                setData(res);
            } catch (e) {
                setError(e?.message || "Fehler beim Laden der Streamer-Daten.");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const rows = useMemo(() => {
        const headers = data.header || [];
        const rowsObj = data.rows || [];

        // zu Array [fahrer, link, team]
        const arr = rowsObj.map((r) => [
            r[headers[0]],
            r[headers[1]],
            r[headers[2]],
        ]);

        // Header-Zeile rausfiltern + leere Zeilen raus
        return arr.filter(([fahrer, link, team]) => {
            const f = String(fahrer ?? "").trim();
            const l = String(link ?? "").trim();
            const t = String(team ?? "").trim();

            if (!f && !l && !t) return false;

            if (
                f.toLowerCase() === "fahrer" &&
                l.toLowerCase() === "link"
            ) {
                return false;
            }

            return true;
        });
    }, [data]);

    return (
        <>
            <div className="card overview-card">
                <h2>Streamer</h2>
                <p className="muted">
                    Hier findest du die Stream-Links aller Fahrer.
                </p>
            </div>

            {loading && (
                <div className="card overview-card">
                    <p>Lade Streamer-Liste …</p>
                </div>
            )}

            {!loading && error && (
                <div className="card overview-card">
                    <p className="muted" style={{ color: "#f55" }}>{error}</p>
                </div>
            )}

            {!loading && !error && (
                <div className="card overview-card">
                    <div className="fancyTable">
                        <table className="tbl tbl-overview-table overview-table">
                            <thead>
                            <tr>
                                <th className="align-left">Fahrer</th>
                                <th className="align-left">Link</th>
                                <th className="align-left">Team</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td className="align-left" colSpan={3}>
                                        Noch keine Streamer eingetragen.
                                    </td>
                                </tr>
                            ) : (
                                rows.map(([fahrer, link, team], idx) => (
                                    <tr key={idx}>
                                        <td className="align-left">{fahrer}</td>
                                        <td className="align-left">{renderChannelLink(link)}</td>
                                        <td className="align-left">{team}</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
}